<template>
  <!-- v-if="tab.label.includes('我的')" -->

  <van-popover s v-model="show" theme="dark" trigger="click" v-bind="$attrs">
    <p
      style="
        padding: 6px;
        line-height: 1.6;
        width: 10em;
        font-size: var(--set-font-size14);
      "
    >
      {{ content }}
    </p>
    <template #reference>
      <van-icon name="info" size="18px" color="#E7E7E8" />
    </template>
  </van-popover>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'Tooltip',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
    },
    content: {
      type: String,
    },
  },
  setup(props, ctx) {
    const show = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        ctx.emit('update:modelValue', val)
      },
    })

    return {
      show,
    }
  },
})
</script>

<style scoped lang="scss"></style>
